import NCSModel from '../../../models/secure/NCSModel';

// Payload required: value (of itemId)
const retrieveProduct = async (context, payload) => {
    let ncsModel = new NCSModel();
    return ncsModel.getItemInfo({ itemId: payload }).then(res => {
        let commitTarget = (res.data && res.data.status == NCSModel.STATUS_SUCCESS) ? 'SET_PRODUCT' : 'CLEAR_PRODUCT';
        context.commit(commitTarget, res.data.records);
        return res.data;
    }).catch(err => {
        return {
            status: "ERROR",
            description: err + " - Failed to connect to server"
        };
    });
}

const retrieveProducts = async (context) => {
    let ncsModel = new NCSModel();
    return ncsModel.getItemsInfo().then(res => {
        if(res.data && res.data.status == NCSModel.STATUS_SUCCESS){
            context.commit('SET_PRODUCTS', res.data.records);
        } else {
            context.commit('CLEAR_PRODUCTS');
        }
        return res.data;
    }).catch(err => {
        return {
            status: "ERROR",
            description: err + " - Failed to connect to server"
        };
    });
}

const setProductTypes = (context, payload) => {
    context.commit('SET_PRODUCT_TYPES', payload);
}

// Payload required: { custId: value, itemId: value }
const retrieveSubscription = async (context, payload) => {
    let ncsModel = new NCSModel();
    return ncsModel.getUserSubscription(payload).then(res => {
        if(res.data && res.data.status == NCSModel.STATUS_SUCCESS){
            context.commit('SET_SUBSCRIPTION', res.data.records);
        } else {
            context.commit('CLEAR_SUBSCRIPTION');
        }
        return res.data;
    }).catch(err => {
        return {
            status: "ERROR",
            description: err + " - Failed to connect to server"
        };
    });
}

// Payload required: { custId: value }
const getCurrentSubscription = async (context, payload) => {
    let ncsModel = new NCSModel();
    return ncsModel.getCurrentSubscription({ custId: payload }).then(res => {
        if(res.data && res.data.status == NCSModel.STATUS_SUCCESS){
            context.commit('SET_CURRENT_SUBSCRIPTION', res.data.records);
        } else {
            context.commit('CLEAR_CURRENT_SUBSCRIPTION');
        }
        return res.data;
    }).catch(err => {
        return {
            status: "ERROR",
            description: err + " - Failed to connect to server"
        };
    });
}
// Payload required: { custId: value }
const retrieveOtherSubscription = async (context, payload) => {
    let ncsModel = new NCSModel();
    return ncsModel.getOtherSubscription(payload).then(res => {
        if(res.data && res.data.status == NCSModel.STATUS_SUCCESS){
            context.commit('SET_OTHER_SUBSCRIPTION', res.data.records);
        } else {
            context.commit('CLEAR_OTHER_SUBSCRIPTION');
        }
        return res.data;
    }).catch(err => {
        return {
            status: "ERROR",
            description: err + " - Failed to connect to server"
        };
    });
}

// Payload required: { custId: value }
const countPreviousItemSubscriptions = async (context, payload) => {
    let ncsModel = new NCSModel();
    return ncsModel.countPreviousItemSubscriptions(payload).then(res => {
        return res.data;
    }).catch(err => {
        return {
            status: "ERROR",
            description: err + " - Failed to connect to server"
        };
    });
}

// Payload required: { custId: value }
const getPreviousItemSubscriptions = async (context, payload) => {
    let ncsModel = new NCSModel();
    return ncsModel.getPreviousItemSubscriptions(payload).then(res => {
        if(res.data && res.data.status == NCSModel.STATUS_SUCCESS){
            context.commit('SET_PREVIOUS_ITEM_SUBSCRIPTIONS', res.data.records);
        } else {
            context.commit('CLEAR_PREVIOUS_ITEM_SUBSCRIPTIONS');
        }
        return res.data;
    }).catch(err => {
        return {
            status: "ERROR",
            description: err + " - Failed to connect to server"
        };
    });
}

// Payload required: { custId: value, itemid: value }
const retrievePreviousAnyItemSubscriptions = async (context, payload) => {
    let ncsModel = new NCSModel();
    return ncsModel.getPreviousAnyItemSubscriptions(payload).then(res => {
        if(res.data && res.data.status == NCSModel.STATUS_SUCCESS){
            context.commit('SET_PREVIOUS_ANY_ITEM_SUBSCRIPTIONS', res.data.records);
        } else {
            context.commit('CLEAR_PREVIOUS_ANY_ITEM_SUBSCRIPTIONS');
        }
        return res.data;
    }).catch(err => {
        return {
            status: "ERROR",
            description: err + " - Failed to connect to server"
        };
    });
}

// Payload required: { custId: value }
const retrieveSubscriptions = async (context, payload) => {
    let ncsModel = new NCSModel();
    return ncsModel.getAllSubscriptionStatus(payload).then(res => {
        if(res.data && res.data.status == NCSModel.STATUS_SUCCESS){
            context.commit('SET_SUBSCRIPTIONS', res.data.records);
        } else {
            context.commit('CLEAR_SUBSCRIPTIONS');
        }
        return res.data;
    }).catch(err => {
        return {
            status: "ERROR",
            description: err + " - Failed to connect to server"
        };
    });
}

// Payload required: { custId: value, itemId: value }
const getItemTransactionHistory = async (context, payload) => {
    let ncsModel = new NCSModel();
    return ncsModel.getItemTransactionHistory(payload).then(res => {
        if(res.data && res.data.status == NCSModel.STATUS_SUCCESS){
            context.commit('SET_ITEM_TRANSACTION_HISTORY', res.data.records);
        } else {
            context.commit('CLEAR_ITEM_TRANSACTION_HISTORY');
        }
        return res.data;
    }).catch(err => {
        return {
            status: "ERROR",
            description: err + " - Failed to connect to server"
        };
    });
}

const dateExpired = async (context, payload) => {
    let ncsModel = new NCSModel();
    return ncsModel.dateExpired(payload).then(res => {
        return res.data;
    }).catch(err => {
        return {
            status: "ERROR",
            description: err + " - Failed to connect to server"
        };
    });
}

// Payload required: { custId: value, orderId: value }
const getReceiptItemInfo = async (context, payload) => {
    let ncsModel = new NCSModel();
    return ncsModel.getReceiptItemInfo(payload).then(res => {
        if(res.data && res.data.status == NCSModel.STATUS_SUCCESS){
            context.commit('SET_RECEIPT_ITEM_INFO', res.data);
        } else {
            context.commit('CLEAR_RECEIPT_ITEM_INFO');
        }
        return res.data;
    }).catch(err => {
        return {
            status: "ERROR",
            description: err + " - Failed to connect to server"
        };
    });
}

// Payload required: { orderNo: value, paymentLogSeq: value }
const retrieveReceiptInfo = async (context, payload) => {
    let ncsModel = new NCSModel();
    return ncsModel.getReceiptInfo(payload).then(res => {
        if(res.data && res.data.status == NCSModel.STATUS_SUCCESS){
            context.commit('SET_RECEIPT_INFO', res.data);
        } else {
            context.commit('CLEAR_RECEIPT_INFO');
        }
        return res.data;
    }).catch(err => {
        return {
            status: "ERROR",
            description: err + " - Failed to connect to server"
        };
    });
}

// Payload required: { orderNo: value, paymentLogSeq: value }
const updateReceiptStatus = async (context, payload) => {
    let ncsModel = new NCSModel();
    return ncsModel.updateReceiptStatus(payload).then(res => {
        if(res.data && res.data.status == NCSModel.STATUS_SUCCESS){
            context.commit('SET_RECEIPT_STATUS', res.data);
        } else {
            context.commit('CLEAR_RECEIPT_STATUS');
        }
        return res.data;
    }).catch(err => {
        return {
            status: "ERROR",
            description: err + " - Failed to connect to server"
        };
    });
}

// Payload required: custId value
const getActiveFreeMonth = async (context, payload) => {
    let ncsModel = new NCSModel();
    return ncsModel.activeFreeMonth({custId: payload}).then(res => {
        if(res.data && res.data.status == NCSModel.STATUS_SUCCESS){
            context.commit('SET_ACTIVE_FREE_MONTH', res.data.records);
        } else {
            context.commit('CLEAR_ACTIVE_FREE_MONTH');
        }
        return res.data;
    }).catch(err => {
        return {
            status: "ERROR",
            description: err + " - Failed to connect to server"
        };
    });
}

const setChosenItem = (context, payload) => {
    context.commit('SET_CHOSEN_ITEM', payload);
}

const clearStates = (context) => {
    context.commit('CLEAR_STATES');
};

const getNewOrderId = async () => {
    let ncsModel = new NCSModel();
    return ncsModel.getNewOrderId().then(res => {
        return res.data;
    }).catch(err => {
        return {
            status: "ERROR",
            description: err + " - Failed to connect to server"
        };
    });
}

export {
    retrieveProduct,
    retrieveProducts,
    updateReceiptStatus,
    setProductTypes,
    retrieveSubscription,
    getCurrentSubscription,
    retrieveOtherSubscription,
    countPreviousItemSubscriptions,
    getPreviousItemSubscriptions,
    retrievePreviousAnyItemSubscriptions,
    retrieveSubscriptions,
    getReceiptItemInfo,
    retrieveReceiptInfo,
    getItemTransactionHistory,
    dateExpired,
    getActiveFreeMonth,
    setChosenItem,
    clearStates,
    getNewOrderId
}
